import { useEffect } from "react";

interface UseReverseDischargeParams {
  isDischargeCompleted: boolean;
  isViewOnly: boolean;
  canReversedDischarge: boolean;
  handleReverseDischarge: (
    isDischargeCompleted: boolean,
    isViewOnly: boolean,
    canReversedDischarge: boolean
  ) => void;
}

export const useReverseDischarge = (params: UseReverseDischargeParams) => {
  useEffect(() => {
    // Reverses the condition discharge if consult is started with a discharged condition
    //  or if the user links a discharged condition to this consult
    params.handleReverseDischarge(
      params.isDischargeCompleted,
      params.isViewOnly,
      params.canReversedDischarge
    );
  }, [params]);
};
